import { createRouter, RouterProvider } from "@tanstack/react-router";
import { defaultAuthRoute } from "src/hooks/useAuth";
import { routeTree } from "src/routeTree.gen";

// ----------------------------------------------------------------------

const router = createRouter({
	routeTree,
	context: { authentication: defaultAuthRoute },
	basepath: "/"
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
	interface Register {
		router: typeof router;
	}
}

export default function Router() {
	return <RouterProvider router={router} context={{ authentication: defaultAuthRoute }} />;
}
